import { useState } from 'react'
import { ApiFehler, schicke } from '../lib/api'

export function SitzungsAktion({ vorschau = false }: { vorschau?: boolean }) {
  const [laeuft, setLaeuft] = useState(false)
  const [fehler, setFehler] = useState<string | null>(null)
  async function ausfuehren() {
    setLaeuft(true)
    setFehler(null)
    try {
      await schicke(vorschau ? 'DELETE' : 'POST', vorschau ? '/api/preview' : '/api/auth/logout')
      // Vollständiger Seitenwechsel entfernt auch alle zwischengespeicherten Haushaltsdaten.
      window.location.replace('/')
    } catch (e) {
      setFehler(e instanceof ApiFehler ? e.message : 'Bitte erneut versuchen.')
      setLaeuft(false)
    }
  }
  return (
    <div>
      <button
        className="menue-eintrag"
        type="button"
        role={vorschau ? undefined : 'menuitem'}
        disabled={laeuft}
        onClick={() => {
          void ausfuehren()
        }}
      >
        {laeuft ? 'Bitte warten …' : vorschau ? 'Vorschau beenden' : 'Abmelden'}
      </button>
      {fehler ? (
        <p className="fehler" role="alert">
          {fehler}
        </p>
      ) : null}
    </div>
  )
}
